export default class ProjetoService {
  constructor($q, UIService, AuthenticationService, AuthorizationService, Projeto) {
    this.$q = $q;
    this.UI = UIService;
    this.Auth = AuthenticationService;
    this.AuthorizationService = AuthorizationService;
    this.Projeto = Projeto;
    this.user = this.Auth.getUser();
  }

  // Add entry to whereObject (where/whereLiteral) or to whereOrObject depending if there are multiple selections of the same entry
  setWhereField = (data, whereObject, whereOrObject) => {
    // Check if have this entry in whereOr already
    if (whereOrObject.find(x => x.key === data.key)) { // If so, add it here then
      whereOrObject.push({key: data.key, value: data.value});
    } else { // Not in OR, check if there's an entry of this key in whereObject already
      if (whereObject[data.key]) { // Already have an entry for this key, transform it into an OR and add it and the new one
        whereOrObject.push({key: data.key, value: whereObject[data.key]});
        delete whereObject[data.key];
        whereOrObject.push({key: data.key, value: data.value});
      } else { // It's the first entry of this key, use whereObject only
        whereObject[data.key] = data.value;
      }
    }
  };

  // Returns a whereFields object to use in table() remote methods (ativo, interacao)
  // WhereLiteral should be defined locally
  setWhereFields = (customFilters, literal, orsLiteral) => {
    let where = {};
    let whereDates = [];
    let whereNextDates = [];
    let whereLiteral = literal || {};
    let whereOrLiteral = orsLiteral || [];
    let whereOr = [];

    customFilters.forEach(f => {
      let data = {};
      data.key = f.column.selected.id;
      // Generated dates - Assuming if no . exists in field, it's always generated date
      if (f.column.selected.id.split('.').filter(Boolean).length === 1 && f.column.selected.type === 'd') {
        whereNextDates.push({
          key: data.key,
          comp: f.values.selected.val,
          value: f.value,
          format: f.column.selected.format
        });
      } else { // All other cases where fields exist in database
        if (f.column.selected.type === 'o') {
          data.value = f.value;

          this.setWhereField(data, where, whereOr);
        } else {
          if (f.column.selected.type === 'd') {
            whereDates.push({
              key: data.key,
              comp: f.values.selected.val,
              value: f.value,
              format: f.column.selected.format
            });
          } else {
            // if ID doesn't exist, use value (Yes/No cases where id doesn't exist but value does)
            if (f.value.selected.id)
              data.value = f.value.selected.id;
            else
              data.value = f.value.selected.value;

            this.setWhereField(data, whereLiteral, whereOrLiteral);
          }
        }
      }
    });
    return {
      where: where,
      whereDates: whereDates,
      whereNextDates: whereNextDates,
      whereLiteral: whereLiteral,
      whereOr: whereOr,
      whereOrLiteral: whereOrLiteral
    };
  };


  // ISSN in the format ____-____
  isValidISSN = (issn) => {
    if (issn == null || issn == undefined || !issn) return false;
    let m = String(issn).match(/^(\d{4})-(\d{3}[\d|X])$/);
    if (!m) return false;


    let checksum = issn[issn.length - 1];
    let digits = m[1] + m[2];
    digits = digits.slice(0, -1);

    let total = 0;
    for (let i = 0; i < digits.length; i++) {
      total += Number(digits[i]) * (8 - i);
    }

    let result = (11 - (total % 11)) % 11;
    if (result < 10) result = String(result);
    else result = 'X';

    return checksum === result;
  };


  // Check if id exists for Model
  fieldValueExists = (field, value, Model) => {
    let defer = this.$q.defer();
    let where = {};
    where[field] = value;
    Model.count({
      where: where
    }).$promise.then((data) => {
      defer.resolve(data.count > 0);
    }).catch((error) => {
      defer.reject(error);
    });
    return defer.promise;
  };

  // Check if partialData - {key1: data1, key2: data2} is already used in Model, returns count
  // If exceptId, do not search for id: exceptId
  usedPartialDataForModel = (partialData, Model, exceptId) => {
    let defer = this.$q.defer();
    let and = [];
    Object.keys(partialData).forEach(k => {
      let o = {};
      o[k] = partialData[k];
      and.push(o);
    });
    // Exclude exceptId
    if (exceptId)
      and.push({id: {neq: exceptId}});

    let where = {and: and};
    Model.count({
      where: where
    }).$promise.then((res) => {
      defer.resolve(res);
    }).catch((error) => {
      defer.reject(error);
    });
    return defer.promise;
  };


  // Go through an array of field, value and models, and resolve/reject if all fields and values exist/not exist in those tables
  validateMultiData = (data) => {
    let multiDefer = this.$q.defer();

    let tasks = [];
    for (let i = 0; i < data.length; i++) {
      let defer = this.$q.defer();

      this.fieldValueExists(data[i].field, data[i].value, data[i].model).then((exists) => {
        if (exists) {
          if (data[i].resolveOnExist) { // Check if it's a "Exists, so resolve" or "Exists, so reject"
            defer.resolve();
          }
          else {
            this.UI.addToast(data[i].error);
            defer.reject();
          }
        } else {
          if (data[i].resolveOnExist) {
            this.UI.addToast(data[i].error);
            defer.reject();
          } else {
            defer.resolve();
          }
        }
      }).catch(err => {
        this.UI.addToast("Não foi possível verificar dados. Verifique a ligação");
        defer.reject();
      });
      tasks.push(defer.promise);
    }

    this.$q.all(tasks).then(x => {
      multiDefer.resolve(tasks);
    }).catch(err => {
      multiDefer.reject(err);
    });

    return multiDefer.promise;
  };

  // Create all multiple data for projeto, referenced by referenceId (ex. projetoId)
  createMultipleData = (Model, data, referenceId, reference) => {
    let multipleDataDefer = this.$q.defer();

    // Create multiple Data
    let tasks = [];
    for (let i = 0; i < data.length; i++) {
      let defer = this.$q.defer();
      let item = data[i];
      item.id = 0;
      item[reference] = referenceId;
      item.criadoPorId = this.user.id;
      item.dataCriacao = moment().format();
      item.atualizadoPorId = this.user.id;
      item.atualizadoa = moment().format();
      Model.create(item).$promise.then((newItem) => {
        defer.resolve(newItem);
      }).catch((error) => {
        console.log(error);
        defer.reject(error);
      });
      tasks.push(defer.promise);
    }

    // After all data is created
    this.$q.all(tasks).then((res) => {
      multipleDataDefer.resolve(tasks);
    }).catch(err => {
      console.log(err);
      multipleDataDefer.reject(err);
    });

    return multipleDataDefer.promise;
  };

  // Update data with criadoPor, dataCriacao; data is array of objects
  updateMultipleData = (Model, data) => {
    let multipleDataDefer = this.$q.defer();

    // Create multiple Data
    let tasks = [];
    for (let i = 0; i < data.length; i++) {
      let defer = this.$q.defer();
      let item = data[i];
      item.atualizadoPorId = this.user.id;
      item.atualizadoa = moment().format();
      Model.upsert(item).$promise.then((newItem) => {
        defer.resolve(newItem);
      }).catch((error) => {
        console.log(error);
        defer.reject(error);
      });
      tasks.push(defer.promise);
    }

    // After all data is updated
    this.$q.all(tasks).then((res) => {
      multipleDataDefer.resolve(tasks);
    }).catch(err => {
      console.log(err);
      multipleDataDefer.reject(err);
    });

    return multipleDataDefer.promise;
  };

  // Check if user is associated with projeto
  getAssociation = (userId, projeto) => {
    let association = {
      isAssociated: false,
      associationCount: 0
    };
    if (!projeto.equipa || projeto.equipa.length === 0)
      return association;
    for (let i = 0; i < projeto.equipa.length; i++) {
      if (projeto.equipa[i].investigador && projeto.equipa[i].investigador.userId === userId) {
        association.isAssociated = true;
        association.associationCount = association.associationCount + 1;
        association.investigadorId = projeto.equipa[i].investigadorId;
      }
    }
    return association;
  };

  // Ask confirmation to delete
  confirmDeleteProjeto = (x) => {
    let defer = this.$q.defer();
    let wait = this.UI.showWaiting();
    this.Projeto.findById({id: x.id,
      filter: {
        include: {
          relation: 'equipa',
          scope: {
            include: 'investigador'
          }
        }

      }
    }).$promise.then((projeto) => {
      // Options for modal
      let options = undefined;
      // Check if user is associated (as investigador) with projeto
      let association = this.getAssociation(this.user.id, projeto);

      // If created projeto and has appropriate permission
      if ((this.user.id === x.criadoPorId && this.AuthorizationService.canPerform('projetoDelete')) || this.AuthorizationService.canPerform('projetoDeleteAny')) {
        // If user has relation with projeto
        if (association.isAssociated) {
          // Only user to be related (if at all) with projeto
          let otherAssociations = projeto.equipa.length - association.associationCount;
          if (otherAssociations === 0) {
            options = {
              title: "Remover Projeto",
              message: "Tem a certeza que pretende remover este projeto?",
              firstButtonLabel: "Apagar Projeto"
            };
          } else { // There are other users related to projeto
            options = {
              title: "Remover Projeto",
              message: "Há " + otherAssociations + (otherAssociations === 1 ? " outra ligação de investigador" : " outras ligações de investigadores") + " à equipa do projeto. Tem a certeza que pretende remover o projeto ou apenas o registo global da sua ligação ao projeto?",
              secondButtonLabel: "Apagar Ligação ao Projeto",
              firstButtonLabel: "Apagar Projeto"
            };
          }
        } else { // User has no relation with projeto, but created it
          options = {
            title: "Remover Projeto",
            message: "Há " + projeto.equipa.length + (projeto.equipa.length === 1 ? " ligação de investigador" : " ligações de investigadores") + " a este projeto. Tem a certeza que pretende remover o projeto e consequentemente apagar todas as ligações ao projeto?",
            firstButtonLabel: "Apagar Projeto"
          };
        }
      } else { // Did not create projeto
        // Has association with projeto
        if (association.isAssociated) {
          options = {
            title: "Remover Ligação a Projeto",
            message: "Tem a certeza que pretende remover o registo global da sua ligação ao projeto?",
            secondButtonLabel: "Apagar Ligação ao Projeto"
          };
        } else { // Has no association with projeto
          options = {
            title: "Remover Projeto",
            message: "Não tem permissões para eliminar este projeto",
            cancelButtonLabel: "Fechar"
          };
        }
      }

      this.modalDeleteProjeto(x, options).then(selection => {
        if (selection.firstButton) {
          // Delete projeto
          this.Projeto.deleteProjeto({id: x.id}).$promise.then(() => {
            wait.close();
            this.UI.addToast("Projeto removido com sucesso");
            defer.resolve();
          }).catch (error => {
            wait.close();
            console.log(error);
            let alert = this.UI.showAlert("Erro ao remover projeto" + (error.message ? (": " + error.message) : (".")));
            alert.finally(() => {
              defer.resolve();
            });
          });
        } else if (selection.secondButton) {
          // Delete all instances as membro da equipa
          this.Projeto.removeMembroEquipa({investigadorId: association.investigadorId, projetoId: x.id}).$promise.then(() => {
            wait.close();
            this.UI.addToast("Removidas todas as ligações ao projeto com sucesso");
            defer.resolve();
          }).catch(error => {
            wait.close();
            console.log(error);
            let alert = this.UI.showAlert("Erro ao remover enquanto membro da equipa" + (error.message ? (": " + error.message) : (".")));
            alert.finally(() => {
              defer.resolve();
            });
          });
        } else {
          // Do nothing
          wait.close();
          defer.resolve();
        }
      }).catch(err => { // Shouldn't get here
        console.log(err);
        wait.close();
        defer.resolve();
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível consultar projeto. Verifique a ligação");
      defer.resolve();
    });
    return defer.promise;
  };

  // Show modal with appropriate options
  modalDeleteProjeto = (x, options) => {
    let defer = this.$q.defer();
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../interface/modals/delete-selected-options.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = options.title;
        $scope.message = options.message;
        $scope.cancelButtonLabel = options.cancelButtonLabel || 'Cancelar';
        $scope.firstButtonLabel = options.firstButtonLabel;
        $scope.secondButtonLabel = options.secondButtonLabel;
        $scope.firstButtonSelected = false;
        $scope.secondButtonSelected = false;

        $scope.firstButton = function () {
          $scope.$close({firstButton: true});
        };
        $scope.secondButton = function () {
          $scope.$close({secondButton: true});
        };

        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then((selection) => {
      defer.resolve(selection);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
      defer.resolve({});
    });
    return defer.promise;
  };

  // Permissions

  getEquipaUserId = (data) => {
    if (data) {
      let ids = [data.criadoPorId];
      if (data.equipa) {
        ids = ids.concat(data.equipa.map(x => x.investigador ? x.investigador.userId : null));
      }
      if (data.investigador && data.investigador.userId) {
        ids.push(data.investigador.userId);
      }
      if (data.coInvestigador && data.coInvestigador.userId) {
        ids.push(data.coInvestigador.userId);
      }
      return ids;
    } else {
      return [];
    }
  };

  // Returns true or false if the user can edit something or not
  // ownPermission - permission to read your instance
  // allowAll - can read all instances of
  // adminPermission - permission to read all instances
  canRead = (ownPermission, allowAll, adminPermission, users) => {
    // If you have admin permission, return true
    if (this.AuthorizationService.canPerform(adminPermission)) {
      return true;
    } else {
      if (this.AuthorizationService.canPerform(ownPermission)) {
        if (allowAll) {
          return true;
        } else {
          return !!(users && users.includes(this.user.id));
        }
      } else {
        return false;
      }
    }
  };

  // Returns true or false if the user can edit something or not
  // ownPermission - permission to edit your instance
  // allowOwn - can edit your own
  // adminPermission - permission to read all instances
  canEdit = (ownPermission, allowOwn, adminPermission, users) => {
    // If you have admin permission, return true
    if (this.AuthorizationService.canPerform(adminPermission)) {
      return true;
    } else {
      if (!allowOwn) {
        return false;
      } else {
        if (users && users.includes(this.user.id)) {
          return this.AuthorizationService.canPerform(ownPermission);
        } else {
          return false;
        }
      }
    }
  };

  // Format bytes into correct units
  formatBytes = (bytes, decimals) => {
    if (bytes == null) return "N/D";
    if (bytes === 0) return '0 Bytes';
    let k = 1024,
      dm = decimals <= 0 ? 0 : decimals || 2,
      sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  };

  generateUUID = () => {
    let uuid = "", i, random;
    for (i = 0; i < 32; i++) {
      random = Math.random() * 16 | 0;
      if (i == 8 || i == 12 || i == 16 || i == 20) {
        uuid += "-";
      }
      uuid += (i == 12 ? 4 : (i == 16 ? (random & 3 | 8) : random)).toString(16);
    }
    return uuid;
  };

  isValidURL = (url) => {
    if (url == null || url.length === 0) return true;
    const regex = new RegExp(
      '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', // fragment locator
      'i'
    );
    return regex.test(url);
  };

  isValidSlug = (slug) => {
    if (typeof slug !== "string") return false;
    // WordPress-like: a-z, 0-9, separated by single hyphens
    // - no leading/trailing hyphen
    // - no consecutive hyphens
    // - no uppercase, accents, underscores, spaces, etc.
    return /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(slug);
  };

  // Checks if exists Slug anywhere. If id is provided find elsewhere (because it might exist here)
  checkExistingSlug = (slug, id) => {
    let defer = this.$q.defer();
    let where = {
      and: [{slug: slug}]
    };
    if (id) where.and.push({id: {neq: id}});
    this.Projeto.find({
      filter: {
        where: where
      }
    }).$promise.then((res) => {
      if (res.length > 0) {
        defer.resolve(true); // Already exists
      } else {
        defer.resolve(false); // Does not exist
      }
    }).catch((error) => {
      defer.reject(error);
    });
    return defer.promise;
  };

  // Receives an input and returns a string with a slug
  stringToSlug = (input) => {
    if (input == null) return "";

    let str = String(input).trim().toLowerCase();

    // Common special-letter transliterations (extra-safe; PT mostly needs ç + accents)
    const map = {
      ß: "ss", æ: "ae", œ: "oe",
      đ: "d", ð: "d", þ: "th",
      ł: "l", ø: "o",
    };
    str = str.replace(/[ßæœđðþłø]/g, (m) => map[m] || m);

    // Remove diacritics (áàâã éê í óôõ ú ü ç -> a a a a e e i o o o u u c)
    // NFKD is slightly more aggressive than NFD (good for “whatnot” input)
    str = str.normalize("NFKD").replace(/[\u0300-\u036f]/g, "");

    // Turn apostrophes/quotes into nothing (so "d'água" -> "dagua")
    str = str.replace(/['"“”‘’`´]/g, "");

    // Replace anything that isn’t a-z or 0-9 with a dash
    str = str.replace(/[^a-z0-9]+/g, "-");

    // Collapse multiple dashes and trim
    str = str.replace(/-+/g, "-").replace(/^-|-$/g, "");

    return str;
  };

}

ProjetoService.$inject = ['$q', 'UIService', 'AuthenticationService', 'AuthorizationService', 'Projeto'];
